import { formatNameForDisplay } from "./nameFormatUtils";

/** Normalize names for case-insensitive duplicate comparison. */
export const normalizeCatalogName = (value) =>
  (value || "").toString().trim().toLowerCase().replace(/\s+/g, " ");

export const getMedicineDisplayName = (medicine) =>
  formatNameForDisplay(medicine?.medicineName || medicine?.name || "");

export const getPathItemDisplayName = (item) =>
  formatNameForDisplay(item?.name || "");

export const duplicateNameErrorMessage = (entityLabel, existingName) =>
  `${entityLabel} "${existingName}" already exists. Names are case-insensitive.`;

/**
 * Check if a name already exists in a catalog list.
 */
export const isDuplicateCatalogName = (
  name,
  existingItems,
  { excludeId = null, getName = (item) => item?.name, getId = (item) => item?.id } = {}
) => {
  const normalized = normalizeCatalogName(name);
  if (!normalized) return false;

  return (Array.isArray(existingItems) ? existingItems : []).some((item) => {
    const itemId = getId(item);
    if (
      excludeId != null &&
      itemId != null &&
      String(itemId) === String(excludeId)
    ) {
      return false;
    }
    return normalizeCatalogName(getName(item)) === normalized;
  });
};

export const findDuplicateCatalogName = (
  name,
  existingItems,
  options = {}
) => {
  const {
    excludeId = null,
    getName = (item) => item?.name,
    getId = (item) => item?.id,
  } = options;
  const normalized = normalizeCatalogName(name);
  if (!normalized) return null;

  return (
    (Array.isArray(existingItems) ? existingItems : []).find((item) => {
      const itemId = getId(item);
      if (
        excludeId != null &&
        itemId != null &&
        String(itemId) === String(excludeId)
      ) {
        return false;
      }
      return normalizeCatalogName(getName(item)) === normalized;
    }) || null
  );
};

/** Returns error message string or null if name is unique. */
export const validateUniqueCatalogName = ({
  name,
  items,
  excludeId = null,
  getName = (item) => item?.name,
  getId = (item) => item?.id,
  entityLabel = "Item",
}) => {
  const duplicate = findDuplicateCatalogName(name, items, {
    excludeId,
    getName,
    getId,
  });
  if (!duplicate) return null;
  return duplicateNameErrorMessage(entityLabel, getName(duplicate));
};
